import {parse_url} from "./tools";

const Request = parse_url(location.href);

export default Request;
